import HTTPClient from './http-client';
import { createUrl } from "../utils_functions";
const END_POINT = '/hourlysummary';

const options = {
  cache: {
      maxAge: 5 * 60 * 1000,
      exclude: { query: false }
  }
}

const loadHourlySummary = async ({ datetime_end, datetime_start, operation_ids, organization_ids, sensor_ids, sort, station_ids, stationtype_ids }) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  const url = createUrl(END_POINT, { datetime_end, datetime_start, operation_ids, organization_ids, sensor_ids, sort, station_ids, stationtype_ids });
  return api.get(url, options);
}

export {
  loadHourlySummary,
}
